<div class="form-group" ngModelGroup="formField{{ formField.id }}">
    <sb-form-field-label [formField]="formField" [labelForPostfix]="'-zip-code'"></sb-form-field-label>
    <div class="address-container">
        <div class="zip-code">
            <input
                type="text"
                autocomplete="postal-code"
                id="form-element-{{ formField.id }}-zip-code"
                name="postal-code"
                pattern="^[0-9]{4,6}"
                [ngClass]="{
                    'ng-invalid':
                        (formField.valueModel.zipCode?.trim() && field.errors?.pattern) || isRequiredZipCodeEmpty(),
                }"
                #field="ngModel"
                class="form-control"
                appFocus
                [appAutoFocus]="formField.isNeedToFocus"
                [placeholder]="zipCodePlaceholder"
                [(ngModel)]="formField.valueModel.zipCode"
                (ngModelChange)="change()"
                [required]="formField.options?.isZipCodeRequired === 'true'" />
        </div>
        <div class="address">
            <input
                id="form-element-{{ formField.id }}-city"
                autocomplete="address-level2"
                type="text"
                name="address-level2"
                class="form-control"
                appWhitespaceValidator
                maxlength="1000"
                [placeholder]="addressPlaceholder"
                [required]="formField.options?.isAddressRequired === 'true'"
                [needToCheck]="formField.options?.isAddressRequired === 'true'"
                [(ngModel)]="formField.valueModel.address"
                (ngModelChange)="change()" />
        </div>
    </div>
    @if (formService.isSubmitted && formField.valueModel.zipCode?.trim() && field.errors?.pattern) {
        <div class="text-danger" translate>ZIP code is invalid</div>
    }
    @if (formService.isSubmitted && isRequiredValueEmpty()) {
        <div class="text-danger" translate>Please fill this field</div>
    }
</div>
